import { Breadcrumb } from '@components/common/Breadcrumb';
import { SidebarWrapper } from '@components/common/SidebarWrapper/SidebarWrapper';
import { buildArticleLink } from '@utils/link';
import NextLink from 'next/link';
import { Container, Heading } from './ArticleTopReads.styles';
import { ArticleTopReadsProps } from './ArticleTopReads.types';

export const ArticleTopReads = ({ articles, heading }: ArticleTopReadsProps) => {
  return (
    <SidebarWrapper heading={heading}>
      {articles?.map((article) => (
        <Container>
          <Breadcrumb
            category={article.categories?.[0]}
            subcategory={article.subcategories?.[0] ?? null}
            breadcrumbSize="small"
          />
          <NextLink href={buildArticleLink(article.id, article.slug)} passHref>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a>
              <Heading>{article.title}</Heading>
            </a>
          </NextLink>
        </Container>
      ))}
    </SidebarWrapper>
  );
};
